import { createPubSubHooks } from "@/shared/utils/pubSub";

type FieldType = "event" | "familyMember";
type Callback = (param: { fieldName: string; type: FieldType; newItemIndex: number; mappedAssertion: string }) => void;

export const [useAddFieldTrigger, useOnAddField] = createPubSubHooks<Callback>();
